import PropTypes from 'prop-types';
import {Component} from 'react';
import {getErrors as getValidationErrors} from './validate-util';
import ValidationMessage from './ValidationMessage/ValidationMessage';

class Validation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.validate = this.validate.bind(this);
  }
  
  componentDidMount() {
    this.props.fieldContainer.registerField(this);
  }
  
  componentWillUnmount() {
    this.props.fieldContainer.deregisterField(this);
  }
  
  validate() {
    let {validate} = this.props;
    if (!validate) {
      return {
        isValid: true,
      };
    }
    if (typeof validate === 'function') {
      validate = [validate];
    }
    const errors = getValidationErrors(validate);
    this.setState({
      errorText: errors.text[0],
    });
  
    return {
      isValid: errors.text.length === 0,
      errors: (errors.text.length === 0) ? undefined : errors.errorCode[0],
    };
  }
  
  render() {
    this.props.validationCallback && (this.props.validationCallback.isValid = this.validate);
    if (this.state.errorText) {
      return <ValidationMessage errorText={this.state.errorText} />;
    }
    return null;
  }
}

Validation.propTypes = {
  fieldContainer: PropTypes.object.isRequired,
  validate: PropTypes.func.isRequired,
  validationCallback: PropTypes.object, // Facilitates manual (not from fieldContainer) invocation of validation
};

export default Validation;
